<template>
  <div class="grid-container fluid featured mtxl">
    <div class="featured-grid grid-container grid-padding-x">
      <h2 class="header">
        {{ $t("news.featured-news") }}
      </h2>
      <hr>
      <div
        v-for="(item, index) in featuredItems"
        :key="index"
        class="featured-item"
      >
        <a
          :href="item.link"
          class="faux-card grid-x"
        >
          <div class="cell large-6 flex-child-auto">
            <img
              :src="item.featured_image"
              alt=""
            >
          </div>
          <div class="cell featured-content pam large-18 grid-x">
            <div class="cell align-self-top post-label post-label--post">
              <header class="mvm">
                {{ item.title }}
              </header>
            </div>
            <div class="cell align-self-bottom">
              <div class="post-meta">
                <span class="date-published">
                  <time :datetime="item.date">{{ formatDate(item.date) }}</time>
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="grid-container group">
      <a
        class="button float-right content-type-featured mbxl"
        href="https://www.phila.gov/the-latest/"
        aria-label="See all news"
      >
        {{ $t("news.see-all-news") }}
        <i
          class="fas fa-angle-right fa-lg"
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      featuredAPIUrl: process.env.VUE_APP_FEATURED_API_URL,
      featuredItems: null,
    };
  },
  computed: {},
  mounted() {
    this.getFeaturedItems();
  },
  methods: {
    async getFeaturedItems() {
      try {
        const response = await axios.get(this.featuredAPIUrl);
        this.featuredItems = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    },
  },
};
</script>
